var CustomSmdPadGeneratorData = {
    addCustomFootprintMembers: function () {
        this.hasCustomFootprint = this.value("hasCustomFootprint", true);
        this.customPadWidth = this.value("customPadWidth", true);
        this.customOddPadWidth = this.value("customOddPadWidth", true);
        this.customPadLength = this.value("customPadLength", true);
        this.customOddPadLength = this.value("customOddPadLength", true);
        this.customPadToPadGap = this.value("customPadToPadGap", true);
        this.customPadToPadGap1 = this.value("customPadToPadGap1", true);
        this.customPadDiameter = this.value("customPadDiameter", true);
        this.customPadSpan1 = this.value("customPadSpan1", true);
        this.customPadSpan2 = this.value("customPadSpan2", true);
        this.customPadPitch = this.value("customPadPitch", true);
        this.pinPitch1 = this.value("pinPitch1", true);
    }
};

module.exports = CustomSmdPadGeneratorData;
